module.exports = __webpack_public_path__ + "img/defaultAccountImage.0dbcc468.png";